import { Component } from "@angular/core";
import { CommonModule, Location } from "@angular/common";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { REQUEST_ERROR, ROUTING_TRAMITE_PENSION, VOUCHER_PENSION } from "@constants/url.constant";
import { GtmService } from "@services/gtm/gtm.service";
import { PiHelpFooterComponent } from "../pi-help-footer/pi-help-footer.component";
import { PiStepperComponent } from "../pi-stepper/pi-stepper.component";
import { ModalHostComponent } from "../../service/modal-host.component";
import { BotonVolverComponent } from "../boton-volver/boton-volver.component";
import { PiIndicadorFlujoComponent } from "../pi-indicador-flujo/pi-indicador-flujo.component";

@Component({
  selector: "app-pi-solicitud-layout",
  templateUrl: "./pi-solicitud-layout.component.html",
  styleUrls: ["./pi-solicitud-layout.component.scss"],
  imports: [RouterModule, PiHelpFooterComponent, PiStepperComponent, ModalHostComponent, BotonVolverComponent, PiIndicadorFlujoComponent, CommonModule],
  standalone: true
})

export class PiSolicitudLayoutComponent {
  

  constructor(private readonly activatedRoute: ActivatedRoute, readonly router: Router, private readonly gtmService: GtmService, private readonly location: Location) { 
    
  }

  goBack() {
    this.location.back();
  }

  goToVoucherPension() {
    this.router.navigate([`/${ROUTING_TRAMITE_PENSION.BASE_URL}/${VOUCHER_PENSION}`], {
      relativeTo: this.activatedRoute,
    });
  }

  goToRequestError() {
    this.router.navigate([`/${ROUTING_TRAMITE_PENSION.BASE_URL}/${REQUEST_ERROR}`], {
      relativeTo: this.activatedRoute,
    });
  }
}
